import { Component } from '@angular/core';
@Component({
	templateUrl: './projeto.component.html',
})

export class ProjetoComponent{
}